import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

export const SET_LISTA_USUARIOS_MATRICULAS = "setListUsuariosMatriculas"
export const SET_LISTA_USUARIOS_PESQUISA = "setListUsuariosPesquisa"
export const SET_LISTA_MATRICULAS_USUARIO = "setListMatriculasUsuarios"
export const SET_MESSAGE_ALERT = 'setMensagem'
const actions = {
    async create_usuario(context, value) {
        let message = await ApiService.post('usuario/criar', value)
            .then(response => ({tipo: 'success', message: response.data}))
            .catch((error) => ({tipo: 'error', message: error.response.data}))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async update_usuario(context, value) {
        let message = await ApiService.put('usuario/atualizar/'+value.id, value)
            .then(response => ({tipo: 'success', message: response.data}))
            .catch((error) => ({tipo: 'error', message: error.response.data}))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async listar_usuarios_matriculas(context, params) {
        await ApiService.get('usuario', {params: params})
            .then(response => context.commit(SET_LISTA_USUARIOS_MATRICULAS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async pesquisar_usuarios(context, texto, tipo) {
        await ApiService.get('usuario/', texto, '/', tipo)
            .then(response => context.commit(SET_LISTA_USUARIOS_PESQUISA, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    
    async listar_matriculas_usuario(context, id) {
        await ApiService.get('matricula_grade_curricular/usuario/' + id)
            .then(response =>
                context.commit(SET_LISTA_MATRICULAS_USUARIO, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    
    async troca_senha(context, value) {
        let message = await ApiService.put('usuario/trocar/senha/'+value.id, value)
            .then(response => ({tipo: 'success', message: response.data}))
            .catch((error) => ({tipo: 'error', message: error.response.data}))
        context.commit(SET_MESSAGE_ALERT, message)
    },
};

const getters = {};

const mutations = {
    [SET_LISTA_USUARIOS_MATRICULAS](state, value) {
        state.lista_usuarios_matriculas = value
    },
    [SET_LISTA_USUARIOS_PESQUISA](state, value) {
        state.lista_usuarios_matriculas = value
    },
    [SET_LISTA_MATRICULAS_USUARIO](state, value) {
        state.lista_matriculas_usuario = value
    },
    [SET_MESSAGE_ALERT](state, value) {
        let customMessage;
        if (typeof value.message === "object") {
          let item = Object.entries(value.message)[0];
          customMessage = `${item[0]}: ${item[1][0]}`;
        }
        state.mensagem_alert = {
          tipo: value.tipo,
          message: customMessage ? customMessage : value.message,
        };
      },
};

const state = {
    lista_usuarios_matriculas: [],
    lista_matriculas_usuario: []
};

export default {
    namespaced:true,
    state,
    actions,
    mutations,
    getters
};